import { resources } from '@/translations/resources'
import i18n from 'i18next'
import intervalPlural from 'i18next-intervalplural-postprocessor'
import 'intl-pluralrules'
import { initReactI18next } from 'react-i18next'

export const defaultNS = 'app'

i18n.use(initReactI18next)
    .use(intervalPlural)
    .init({
        resources,
        ns: [defaultNS],
        defaultNS,
        lng: 'cs',
    })

export default i18n
